import ClaimCategory from '../model/ClaimCategory';
import m from './module';
import { getProvisionalIdentifierForType, castToBoolean } from '../util';

const path = '/claim_category';

class ClaimCategoryService {
  constructor($q, $log, APIService, DataSyncService) {
    this.$q = $q;
    this.$log = $log;
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;
  }

  create(data) {
    data = data || {};
    if (!data.id) {
      data.id = getProvisionalIdentifierForType("claimcategory");
      this.$log.warn("Attempt to create ClaimCategory with no ID. Setting provisional ID:", data.id);
    }
    const model = new ClaimCategory(data);
    return this.$q.when(model);
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects('ClaimCategory', path, obj => this.create(obj), config);
  }

  getAllActive() {
    return this.getAll()
      .then(all => all.filter(claimCategory => castToBoolean(claimCategory.active)));
  }

  getById(id, config = null) {
    return this.DataSyncService.getObjectByIdFromMultiple('ClaimCategory', path, id, obj => this.create(obj), config);
  }

  getPrimaryClaimCategory() {
    return this.getAllActive()
      .then(categories => categories.find(category => category.isTimeBased));
  }
}

export default ClaimCategoryService;

m.service('ClaimCategoryService', ClaimCategoryService);
